import { PinInput as $PinInput } from '@mantine/core';
import type { PinInputProps as $PinInputProps } from '@mantine/core';
import { useController } from 'react-hook-form';
import type { FieldValues, UseControllerProps } from 'react-hook-form';

type PinInputProps<T extends FieldValues> = UseControllerProps<T> & Omit<$PinInputProps, 'value' | 'defaultValue'>;

export function PinInput<T extends FieldValues>({
  name,
  control,
  defaultValue,
  rules,
  shouldUnregister,
  onChange,
  ...props
}: PinInputProps<T>) {
  const {
    field: { value, onChange: fieldOnChange, ref: _fieldRef, ...field },
    fieldState,
  } = useController<T>({
    name,
    control,
    defaultValue,
    rules,
    shouldUnregister,
  });

  return (
    <$PinInput
      error={!(fieldState.error?.message == null)}
      radius={4}
      value={value}
      onChange={(e) => {
        fieldOnChange(e);
        onChange?.(e);
      }}
      {...field}
      {...props}
    />
  );
}
